import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import { GameConceptsManager } from "../../../../components/GameConceptsManager";
import { ClarityEvents, trackClarityEvent } from "../../../../clarity";
import { xboxOnboardSiteLocationPrefix } from "../../../../constants";
import { useStrings } from "../../../../localization/localizationHelpers";
import { Programs } from "../../../../models/programsConfig";
import { RouteNames } from "../../../../partnerConfig/routeNames";
import { gameConceptsListActions } from "../../../../redux/actions/gameConceptsListActions";
import {
  getGameConceptsListData,
  getGameConceptsListIsLoading,
  getGameConceptsListQuery,
} from "../../../../redux/selectors/gameConceptsListSelectors";
import { getXboxOnboardData } from "../../../../redux/selectors/xboxOnboardSelectors";
import * as styles from "../../PartnerHomePage.module.css";

type PartnerConceptSectionProps = Readonly<{
  isAaaUser: boolean;
}>;

export const PartnerConceptSection = ({ isAaaUser }: PartnerConceptSectionProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const canCreate = useSelector(getXboxOnboardData)?.hubPermissions.gameConcepts.edit !== "none";
  const [programsLabel] = useStrings("programsLabel");

  const handleCreateConcept = () => {
    trackClarityEvent(ClarityEvents.gameConceptCreated);
    const newId = uuidv4();
    history.push(`${xboxOnboardSiteLocationPrefix}/game-concept/${newId}?isNew=true`);
  };

  return (
    <div className={styles.conceptSection}>
      {!isAaaUser && canCreate && (
        <h2 className={styles.programsSectionTitle}>
          <Link
            to={`${xboxOnboardSiteLocationPrefix}/programs`}
            className={styles.programsSectionLink}
          >
            {programsLabel} <span className={styles.programsChevron}>&#x203A;</span>
          </Link>
        </h2>
      )}
      <GameConceptsManager
        programDashboardRouteName={RouteNames.GameConceptPage}
        program={isAaaUser ? Programs.Aaa : Programs.IdXbox}
        onNewConcept={handleCreateConcept}
        onConceptClick={conceptId =>
          history.push(`${xboxOnboardSiteLocationPrefix}/game-concept/${conceptId}`)
        }
        gameConceptsQuerySelector={getGameConceptsListQuery}
        gameConceptsListSelector={getGameConceptsListData}
        isLoadingSelector={getGameConceptsListIsLoading}
        onFetchGameConcepts={paginatedInfo =>
          dispatch(gameConceptsListActions.fetchGameConcepts.start(paginatedInfo))
        }
        onClearQuery={() => dispatch(gameConceptsListActions.clearQuery())}
        canCreate={canCreate}
      />
    </div>
  );
};
